import { Subject } from 'rxjs'
import { RxJS } from './RxJS'
import { RxJSState } from '../Types/Types'

const localStorageSetSubject: Subject<string> = new Subject<string>()

RxJS.localStorageSet = RxJS.localStorageSet ?? {
    subject: localStorageSetSubject,
    observable: localStorageSetSubject.asObservable(),
    announce: (data: string): void => localStorageSetSubject.next(data)
}

export const localStorageSet$: RxJSState<string> = RxJS.localStorageSet
